// line nav

var ttLineNav = {
  init: function () {
    var nav_el = $('.linenav');

    if (nav_el.length == 0) return;

    var line_nav = function (el) {
      var line_el = el.find('.activeline');
      var li_el = el.find('li');
      var active_el = el.find('li.active');
      var a_pd_left = parseInt(li_el.find('a').css('padding-left'));
      var init_left = 0;
      var init_w = 0;

      if (active_el.length) {
        init_left = active_el.position().left + a_pd_left;
        init_w = active_el.find('a span').innerWidth();

        line_el.css({
          'left': init_left,
          'width': init_w
        });
      }

      li_el.on('mouseover', function () {
        var th = $(this);
        var span_el = th.find('a span');
        var li_pos = th.position();
        var end_left = li_pos.left + a_pd_left;
        var end_w = span_el.innerWidth();
        // console.log('li left: ' + end_left);

        line_el.css({
          'left': end_left,
          'width': end_w
        });
      });

      li_el.on('mouseout', function () {
        if (active_el.length) {
          line_el.css({
            'left': init_left,
            'width': init_w
          });
        } else {
          line_el.css({
            'width': init_w
          });
        }
      });
    }

    nav_el.each(function () {
      line_nav($(this));
    });
  }
}